import { PropsWithChildren, useMemo } from 'react';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#b5734e' },
    secondary: { main: '#274052' },
    error: { main: '#cc0000' },
  },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#a5562b' },
    secondary: { main: '#829AB1' },
    error: { main: '#cc0000' },
  },
});

// Single v7 ThemeProvider for the whole app. StyledEngineProvider injectFirst
// makes emotion-generated styles render BEFORE any plain CSS class selectors,
// so per-component sx/styled rules can be overridden by app-level CSS.
export function RogoThemeProvider({ isDark, children }: PropsWithChildren<{ isDark: boolean }>) {
  const theme = useMemo(() => (isDark ? darkTheme : lightTheme), [isDark]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
